import { Link } from 'react-router-dom';
import SectionHeading from '@/components/feature/SectionHeading';
import { articles } from '@/mocks/articles';
import type { Article } from '@/types/content';

const rank = [...(articles as Article[])].sort((a, b) => b.heat - a.heat).slice(0, 6);
const maxHeat = rank[0].heat;
const labels = ['冠军瓜', '热议瓜', '上升瓜', '口碑瓜', '长线瓜', '潜力瓜'];

export default function HotRankSection() {
  return (
    <section id="hot" className="py-14 md:py-20 bg-foreground-950">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-8 md:mb-10">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-medium tracking-widest text-accent-400 uppercase mb-2">
              <span className="w-5 h-px bg-accent-500"></span>
              Ranking
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 leading-tight">
              近期热点榜
            </h2>
            <p className="mt-2.5 text-sm md:text-base text-background-300 max-w-2xl leading-7">
              按讨论热度实时排序，每小时更新一次。榜单只呈现正在发酵的话题，冷下去的会自动沉淀到瓜料库。
            </p>
          </div>
          <Link
            to="/topics?cat=hot"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-accent-400 hover:text-accent-300 whitespace-nowrap shrink-0 transition-colors"
          >
            查看完整榜单
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        </div>

        <ol className="space-y-2">
          {rank.map((a, i) => (
            <li key={a.id}>
              <Link
                to={`/article/${a.id}`}
                className="group flex items-center gap-4 md:gap-6 px-4 md:px-6 py-4 rounded-lg border border-foreground-800 hover:border-accent-500/60 hover:bg-foreground-900 transition-colors"
              >
                <span
                  className={`font-heading font-bold text-2xl md:text-3xl w-10 shrink-0 text-center ${
                    i < 3 ? 'text-accent-400' : 'text-foreground-500'
                  }`}
                >
                  {String(i + 1).padStart(2, '0')}
                </span>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1.5">
                    <span className="text-[11px] px-2 py-0.5 rounded-full bg-foreground-800 text-background-200 whitespace-nowrap">
                      {a.categoryLabel}
                    </span>
                    <span className="text-[11px] text-foreground-400 whitespace-nowrap hidden sm:inline">
                      {labels[i]}
                    </span>
                  </div>
                  <h3 className="text-sm md:text-base font-medium text-background-100 group-hover:text-accent-300 transition-colors line-clamp-1">
                    {a.title}
                  </h3>
                  <div className="mt-2.5 h-1 rounded-full bg-foreground-800 overflow-hidden">
                    <div
                      className="h-full rounded-full bg-gradient-to-r from-primary-500 to-accent-500"
                      style={{ width: `${Math.round((a.heat / maxHeat) * 100)}%` }}
                    ></div>
                  </div>
                </div>
                <div className="hidden md:flex flex-col items-end shrink-0 w-24">
                  <span className="font-heading font-bold text-lg text-accent-400">{a.heat}</span>
                  <span className="text-[11px] text-foreground-500">讨论热度</span>
                </div>
              </Link>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}